module.exports = __webpack_public_path__ + "d162aca13ae8ea5e53ad6368a2f86ac1.svg";